export class IddPair {
  dataKeyFirstTable: number;
  dataKeySecondTable: number;

  constructor(dataKeyFirstTable: number, dataKeySecondTable: number) {
    this.dataKeyFirstTable = dataKeyFirstTable;
    this.dataKeySecondTable = dataKeySecondTable;
  }
}
